import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PromoModalTitle extends Component {
    render() {
        const { name, description } = this.props;

        return (
            <div className="promos-page-header">
                <h2 classname="h2">{ name }</h2>
                <h3 className="h3 advantage">Take advantage of</h3>
                <h4 className="h4 personal-offer">YOUR PERSONAL OFFER</h4>
	            <h3 className="h3 title-lines"><span>From</span></h3>
	            <h3 className="h3 brand-color">NonExecutiveDirectors.com</h3>
                {/*<p className="p-tag page-subheader">{ description }</p>*/}
            </div>
        );
    }
}

PromoModalTitle.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
};

export default PromoModalTitle;



// WEBPACK FOOTER //
// src/client/components/site/features/promos/elements/PromoModalTitle.js